interface SparklineProps {
  values: number[];
  width?: number;
  height?: number;
  testId?: string;
}

/** Tiny inline trend: last ≤8 points, no axes, strokes currentColor so it inherits text colour. */
export default function Sparkline({ values, width = 64, height = 20, testId }: SparklineProps) {
  const points = values.slice(-8);
  if (points.length < 2) return null;
  const min = Math.min(...points);
  const max = Math.max(...points);
  const span = max - min || 1;
  const step = width / (points.length - 1);
  const path = points
    .map((v, i) => `${i === 0 ? 'M' : 'L'}${(i * step).toFixed(1)},${(height - 2 - ((v - min) / span) * (height - 4)).toFixed(1)}`)
    .join(' ');
  const last = points[points.length - 1];
  return (
    <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} aria-hidden="true" data-testid={testId} className="text-primary">
      <path d={path} fill="none" stroke="currentColor" strokeWidth={1.5} strokeLinejoin="round" strokeLinecap="round" />
      <circle cx={width} cy={height - 2 - ((last - min) / span) * (height - 4)} r={2} fill="currentColor" />
    </svg>
  );
}
